// extracted by mini-css-extract-plugin
export default {"container":"User_container__-895H","avatar":"User_avatar__E1m6j","placeholder":"User_placeholder__6AjpA"};